import React, { useState } from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import PortalLayout from './components/PortalLayout';
import SelectionSummary from './components/SelectionSummary';
import PositionManager from './components/PositionManager';
import PublicationManager from './components/PublicationManager';
import RequirementManager from './components/RequirementManager';
import WindowManager from './components/WindowManager';
import FormSummary from './components/FormSummary';
import FormConfigurationModal from './components/FormConfigurationModal';
import PositionConfigurationModal from './components/PositionConfigurationModal';
import RegistrationConfigurationModal from './components/RegistrationConfigurationModal';
import { can } from '../../permissions';
import ReleaseManager from './components/ReleaseManager';
import SectionButtons from '../ReusableComponents/SectionButtons';
import { useSelecao, usePortal } from './hooks';
import { ErrorNotice, Loading } from './components/Feedback';
const baseModules = [
  {
    value: 'settings',
    label: 'Informações',
    description: 'Publicação, período e condições',
    icon: 'configuracoes',
  },
  {
    value: 'positions',
    label: 'Cargos',
    description: 'Vagas e acesso à avaliação',
    icon: 'processos',
  },
  {
    value: 'form',
    label: 'Formulário',
    description: 'Campos e versões da inscrição',
    icon: 'questoes',
  },
  {
    value: 'publications',
    label: 'Publicações',
    description: 'Editais e comunicados',
    icon: 'conteudos',
  },
  {
    value: 'documents',
    label: 'Documentos',
    description: 'Comprovantes e regras de envio',
    icon: 'imagens',
  },
  {
    value: 'appeals',
    label: 'Recursos',
    description: 'Prazos e critérios de solicitação',
    icon: 'mensagens',
  },
  {
    value: 'releases',
    label: 'Resultados',
    description: 'Cadernos, gabaritos e notas',
    icon: 'relatorios',
  },
];
export default function PortalSelection() {
  const { labels, user } = usePortal();
  const [editing, setEditing] = useState(null);
  const [saved, setSaved] = useState(null);
  const allowed = can(user, 'portal_configuracoes', 'edit');
  const modules = baseModules.map((item) =>
    item.value === 'positions' ? { ...item, label: labels.positions } : item
  );
  const { selection } = useParams(),
    query = useSelecao(selection),
    location = useLocation(),
    history = useHistory(),
    params = new URLSearchParams(location.search),
    value = modules.some((m) => m.value === params.get('modulo'))
      ? params.get('modulo')
      : 'settings',
    s = query.data;
  return (
    <PortalLayout
      title={s?.title || 'Configurar seletivo'}
      description="Organize a publicação e o acompanhamento das inscrições."
    >
      <ErrorNotice error={query.error} />
      {query.isLoading ? (
        <Loading />
      ) : (
        s && (
          <>
            <section className="card module-card detail-summary hidethis">
              <div className="card-body">
                <h2 className="module-selector-title">Escolha um módulo para gerenciar</h2>
                <SectionButtons
                  compact
                  variant="modules"
                  items={modules}
                  value={value}
                  onChange={(v) => {
                    params.set('modulo', v);
                    history.push({
                      pathname: location.pathname,
                      search: params.toString(),
                    });
                  }}
                />
              </div>
            </section>
            {saved && (
              <div
                className={`alert ${saved.sourceChanged ? 'alert-info' : 'alert-success'}`}
                role="status"
              >
                {saved.sourceChanged
                  ? 'Configuração salva. As habilitações foram atualizadas na OnTest; sincronize os seletivos para refletir essas alterações no portal.'
                  : 'Configuração das inscrições salva.'}
              </div>
            )}
            {value === 'settings' && (
              <SelectionSummary
                selection={s}
                allowed={allowed}
                onEdit={() => setEditing({ type: 'settings' })}
              />
            )}
            {value === 'positions' && (
              <>
                <PositionManager
                  selection={s}
                  onEdit={(position) => setEditing({ type: 'position', ...position })}
                />
              </>
            )}
            {value === 'form' && (
              <FormSummary
                selection={s}
                allowed={allowed}
                onEdit={() => setEditing({ type: 'form' })}
              />
            )}{' '}
            {value === 'publications' && <PublicationManager selection={s} />}{' '}
            {value === 'documents' && <RequirementManager selection={s} />}{' '}
            {value === 'appeals' && <WindowManager selection={s} />}{' '}
            {value === 'releases' && <ReleaseManager selection={s} />}
            {editing?.type === 'settings' && (
              <RegistrationConfigurationModal
                selection={s}
                onClose={() => setEditing(null)}
                onSaved={setSaved}
              />
            )}
            {editing?.type === 'position' && (
              <PositionConfigurationModal
                selection={s}
                source={editing.source}
                portal={editing.portal}
                onClose={() => setEditing(null)}
                onSaved={setSaved}
              />
            )}
            {editing?.type === 'form' && (
              <FormConfigurationModal
                selection={s}
                onClose={() => setEditing(null)}
                onSaved={setSaved}
              />
            )}
          </>
        )
      )}
    </PortalLayout>
  );
}
